import { App } from 'vue'
import Vue3Geolocation from 'vue3-geolocation'

export default {
  install: (app: App < Element >) => {
    const vue = app
    vue.use(Vue3Geolocation)
  }
}
